/*global Daon */
/*eslint no-undef: "error"*/
import React, { Component } from "react";
import { string, func, instanceOf } from "prop-types";
// import { PASSPORT } from "../../logic/enums/documentType";
import BlobPreview from "../BlobPreview";
import { connect } from "react-redux";
import { isMobile, isIOS } from "../../logic/deviceType";
import { cameraResolution } from "../../logic/actions/documentCapture";
import ScrollingStopDetector from "../ScrollingStopDetector";

export class DocumentCaptureUI extends Component {
  static propTypes = {
    documentType: string,
    blobPreview: instanceOf(Blob),
    onInitialized: func,
    onCameraStarted: func,
    documentCapture: instanceOf(Daon.DocumentCapture),
  };
  constructor(props) {
    super(props);
    this.state = {
      isMobile: true,
    };
    this.videoRef = new React.createRef();
    this.canvasRef = new React.createRef();
    if (typeof this.props.onInitialized === "function")
      this.props.onInitialized(this.props.docCaptureInstance);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.retryCameraInit !== this.props.retryCameraInit)
      !this.props.retryCameraInit && this.initializeCamera();
  }

  componentDidMount() {
    this.initializeCamera();
    this.setState({ isMobile: isMobile(navigator.userAgent) });
    if (isIOS(navigator.userAgent)) this.setState({ isIOS: true });
  }

  componentDidUpdate(prevProps, _) {
    if (prevProps.cameraId !== this.props.cameraId) {
      this.setNewCamera(this.props.cameraId);
    }
    if (prevProps.coords !== this.props.coords) this.drawCanvasRectangle();
  }

  drawCanvasRectangle = () => {
    const { clientWidth, clientHeight } = document.querySelector(
      ".ui-canvas-container"
    );

    this.canvasRef.current.width = clientWidth;
    this.canvasRef.current.height = clientHeight;

    var ctx = this.canvasRef.current.getContext("2d");

    ctx.lineWidth = 8;
    ctx.lineColor = "blue";
    ctx.strokeStyle = "white";
    ctx.fillStyle = "gray";

    ctx.beginPath();
    ctx.fillRect(
      0,
      0,
      this.canvasRef.current.width,
      this.canvasRef.current.height
    );

    ctx.clearRect(
      this.props.coords.upperCanvasX,
      this.props.coords.upperCanvasY,
      this.props.coords.scanningCanvasRegionWidth,
      this.props.coords.scanningCanvasRegionHeight
    );
    ctx.rect(
      this.props.coords.upperCanvasX,
      this.props.coords.upperCanvasY,
      this.props.coords.scanningCanvasRegionWidth,
      this.props.coords.scanningCanvasRegionHeight
    );
    ctx.stroke();
  };

  initializeCamera() {
    this.props.docCaptureInstance
      .startCamera(this.videoRef.current, this.props.cameraId)
      .then(() => {
        const trackSettings = this.props.docCaptureInstance.camera.videoTracks[0].getSettings();
        this.setState({
          width: trackSettings.width,
          height: trackSettings.height,
        });
        this.props.cameraResolution({
          width: this.state.width,
          height: this.state.height,
        });
        this.props.toggleLoading();
        if (typeof this.props.onCameraStarted === "function") {
          this.props.onCameraStarted(
            this.props.docCaptureInstance,
            this.videoRef.current
          );
        }
      })
      .catch((err) => this.props.cameraPermissionDenied());
  }

  toogleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  setNewCamera = (cameraId) => {
    if (this.videoRef && this.videoRef.current) {
      this.videoRef.current.srcObject = undefined;
    }
    this.props.docCaptureInstance.stopAutoCapture();
    this.props.docCaptureInstance.stopCamera();
    this.props.docCaptureInstance
      .startCamera(this.videoRef.current, cameraId)
      .then(() => {
        if (typeof this.props.onCameraStarted === "function")
          this.props.onCameraStarted(
            this.props.docCaptureInstance,
            this.videoRef.current
          );
      });
  };

  componentWillUnmount = () => {
    if (this.videoRef && this.videoRef.current) {
      this.videoRef.current.srcObject = undefined;
    }
    if (this.props.docCaptureInstance) {
      this.props.docCaptureInstance.stopAutoCapture();
      this.props.docCaptureInstance.stopCamera();
    }
  };

  render() {
    const isEdge = window.navigator.userAgent.indexOf("Edge") > -1;
    const shouldScaleEdge = isEdge ? "ui-canvas scale-edge" : "ui-canvas";
    let containerClassName;
    if (this.props.captureType === "LANDSCAPE") {
      containerClassName = this.state.isIOS
        ? "landscape-safari"
        : "others-landscape";
    } else if (isEdge) {
      containerClassName = "ui-canvas-container hiddenEdge";
    } else {
      containerClassName = "ui-canvas-container";
    }

    const shouldBeFlipped = !this.state.isMobile ? "flip-x" : "";
    const videoClassName = shouldScaleEdge + " " + shouldBeFlipped;
    // const desktopWidth = !this.state.isMobile ? { width: "" } : {};
    return (
      <div className={containerClassName}>
        <ScrollingStopDetector onStop={() => this.drawCanvasRectangle()} />
        <canvas className="calculating-canvas" ref={this.canvasRef}></canvas>
        <video
          className={videoClassName}
          ref={this.videoRef}
          style={{ display: this.props.blobPreview ? "none" : "inherit" }}
        ></video>
        {this.props.blobPreview && (
          <BlobPreview
            className="ui-canvas"
            blob={this.props.blobPreview}
            captureMethod={this.props.captureMethod}
            alt="capture preview"
          />
        )}
      </div>
    );
  }
}
export default connect(
  (state) => {
    return state.documentCapture;
  },
  { cameraResolution }
)(DocumentCaptureUI);
